function scrollToNewsletter() {
  if (window.location.hash === "#contact-with-image-form") {
    const el = document.querySelector(".contact-with-image-section");
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }
  if (window.location.hash === "#ExclusiveNewsletter") {
    const el = document.querySelector(".exclusive-newsletter-overlay");
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }
}

scrollToNewsletter();

document.addEventListener("DOMContentLoaded", scrollToNewsletter);

window.addEventListener("load", scrollToNewsletter);
